import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ConfigService } from '../core/core-config.service';
import { SharedModule } from '../shared/shared.module';
import { CreateSiteInfoApiClientComponent } from './create-siteinfo-api-client/create-siteinfo-api-client.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { ListApiResourcesComponent } from './list-api-resoruces/list-api-resources.component';
import { ClientDetailsComponent } from './client-details/client-details.component';
import { ListClientsComponent } from './list-clients/list-clients.component';
import { ListIdentityResourcesComponent } from './list-identity-resoruces/list-identity-resources.component';
import { ListUsersComponent } from './list-users/list-users.component';
import { ClientService } from './services/client.service';
import { UserService } from './services/user.service';
import { UserManagerRoutingModule } from './user-manager-routing.module';
import { AddClientSecretModalComponent } from './client-details/add-client-secret-modal/add-client-secret.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordModalComponent } from './list-users/change-password-modal.component';



@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        UserManagerRoutingModule,
        NgbModule,
        ChangePasswordModalComponent
    ],
    declarations: [
        CreateUserComponent,
        CreateSiteInfoApiClientComponent,
        ListUsersComponent,
        ListClientsComponent,
        ClientDetailsComponent,
        AddClientSecretModalComponent,
        ListApiResourcesComponent,
        ListIdentityResourcesComponent
    ],
    providers: [
        UserService,
        ClientService,
        ConfigService
    ],
    exports: [
        CreateUserComponent,
        CreateSiteInfoApiClientComponent,
        ListUsersComponent,
        ListClientsComponent,
        ListApiResourcesComponent,
        ListIdentityResourcesComponent        
    ]
})
export class UserManagerModule { }